<ui-tab-group class="hidden md:block">
  <a
    routerLink="./general"
    routerLinkActive
    #general="routerLinkActive"
    [attr.aria-current]="general.isActive"
  >
    <ui-tab [active]="general.isActive">
      <h2 class="flex">
        <ng-icon name="heroInformationCircle" size="20" class="!block mr-2" />
        {{ 'cockpit.locations.details.nav.general' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./energy-interfaces"
    routerLinkActive
    #energyInterfaces="routerLinkActive"
    [attr.aria-current]="energyInterfaces.isActive"
  >
    <ui-tab [active]="energyInterfaces.isActive">
      <h2 class="flex">
        <ng-icon name="heroServerStack" size="20" class="!block mr-2" />
        {{ 'cockpit.locations.details.nav.energyInterfaces' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./consumption"
    routerLinkActive
    #consumption="routerLinkActive"
    [attr.aria-current]="consumption.isActive"
  >
    <ui-tab [active]="consumption.isActive">
      <h2 class="flex">
        <ng-icon name="heroChartPie" size="20" class="!block mr-2" />
        {{ 'cockpit.locations.details.nav.consumption' | transloco }}
      </h2>
    </ui-tab>
  </a>
</ui-tab-group>
<div class="md:hidden">
  <ui-select (selectChange)="onSelectChange($event)">
    <option
      value="./general"
      routerLink="./general"
      routerLinkActive
      #generalMobile="routerLinkActive"
      [selected]="generalMobile.isActive"
    >
      {{ 'cockpit.locations.details.nav.general' | transloco }}
    </option>
    <option
      value="./energy-interfaces"
      routerLink="./energy-interfaces"
      routerLinkActive
      #energyInterfacesMobile="routerLinkActive"
      [selected]="energyInterfacesMobile.isActive"
    >
      {{ 'cockpit.locations.details.nav.energyInterfaces' | transloco }}
    </option>
    <option
      value="./consumption"
      routerLink="./consumption"
      routerLinkActive
      #consumptionMobile="routerLinkActive"
      [selected]="consumptionMobile.isActive"
    >
      {{ 'cockpit.locations.details.nav.consumption' | transloco }}
    </option>
  </ui-select>
</div>
